import { createSlice } from "@reduxjs/toolkit";

type MaintenanceCoverState = {
  isVisible: boolean;
};

const initialState: MaintenanceCoverState = {
  isVisible: false,
};

const maintenanceCoverSlice = createSlice({
  name: "maintenanceCoverSlice",
  initialState,
  reducers: {
    show: (state) => {
      state.isVisible = true;
    },
    reset: () => initialState,
  },
});

export default maintenanceCoverSlice;
